import React from "react";
import { FiCheck, FiX, FiLink, FiClock } from "react-icons/fi";
import { cn } from "utils/helpers";
import type { TriageStatus } from "../../../../types/clarification-review.type";

interface TriageStatusBadgeProps {
	className?: string;
	status: TriageStatus | null;
}

const STATUS_CONFIG: Record<string, { icon: React.ReactNode; label: string; colors: string }> = {
	accepted: {
		icon: <FiCheck size={10} aria-hidden="true" />,
		label: "Accepted",
		colors: "bg-green-100 text-green-700",
	},
	declined: {
		icon: <FiX size={10} aria-hidden="true" />,
		label: "Declined",
		colors: "bg-red-100 text-red-700",
	},
	duplicate: {
		icon: <FiLink size={10} aria-hidden="true" />,
		label: "Duplicate",
		colors: "bg-gray-100 text-gray-600",
	},
	pending: {
		icon: <FiClock size={10} aria-hidden="true" />,
		label: "Pending",
		colors: "bg-amber-100 text-amber-700",
	},
};

export const TriageStatusBadge: React.FC<TriageStatusBadgeProps> = ({
	status,
	className = "",
}) => {
	const key = status ?? "pending";
	const config = STATUS_CONFIG[key] ?? STATUS_CONFIG.pending;

	return (
		<span
			className={cn(
				"inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium",
				config.colors,
				className
			)}
			data-testid={`triage-badge-${key}`}
		>
			{config.icon}
			{config.label}
		</span>
	);
};
